export const onboardA2ADialogIndexEnums = Object.freeze({
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  OPENING: 'OPENING',
  SELECT_INST: 'SELECT_INST',
  SELECT_ACCT: 'SELECT_ACCT',
  ACCT_INFO: 'ACCT_INFO',
  CONFIRM: 'CONFIRM',
  DEPOSITS_SENT: 'DEPOSITS_SENT',
  SUCCESS: 'SUCCESS',
  READY_TO_TRANSFER: 'READY_TO_TRANSFER',
});

export type onboardA2ADialogIndex =
  | 'ERROR'
  | 'LOADING'
  | 'OPENING'
  | 'SELECT_INST'
  | 'SELECT_ACCT'
  | 'ACCT_INFO'
  | 'CONFIRM'
  | 'SUCCESS'
  | 'DEPOSITS_SENT'
  | 'READY_TO_TRANSFER';
